'use strict';

var _toConsumableArray = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var Assert = require('./assert');

var DeepEqual = require('./deepEqual');

var EscapeRegex = require('./escapeRegex');

var Utils = require('./utils');

var internals = {};

module.exports = function (ref, values) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  // options: { deep, once, only, part, symbols }

  /*
      string -> string(s)
      array -> item(s)
      object -> key(s)
      object -> object (key:value)
  */
  if (typeof values !== 'object') {
    values = [values];
  }

  Assert(!Array.isArray(values) || values.length, 'Values array cannot be empty'); // String

  if (typeof ref === 'string') {
    return internals.string(ref, values, options);
  } // Array


  if (Array.isArray(ref)) {
    return internals.array(ref, values, options);
  } // Object


  Assert(typeof ref === 'object', 'Reference must be string or an object');
  return internals.object(ref, values, options);
};

internals.array = function (ref, values, options) {
  if (!Array.isArray(values)) {
    values = [values];
  }

  if (!ref.length) {
    return false;
  }

  if (options.only && options.once && ref.length !== values.length) {
    return false;
  }

  var compare; // Map values

  var map = new Map();

  var _iterator = _createForOfIteratorHelper(values),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var value = _step.value;

      if (!options.deep || !value || typeof value !== 'object') {
        var existing = map.get(value);

        if (existing) {
          ++existing.allowed;
        } else {
          map.set(value, {
            allowed: 1,
            hits: 0
          });
        }
      } else {
        compare = compare || internals.compare(options);
        var found = false;

        var _iterator4 = _createForOfIteratorHelper(map.entries()),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _step4$value = _slicedToArray(_step4.value, 2),
                key = _step4$value[0],
                _existing = _step4$value[1];

            if (compare(key, value)) {
              ++_existing.allowed;
              found = true;
              break;
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }

        if (!found) {
          map.set(value, {
            allowed: 1,
            hits: 0
          });
        }
      }
    } // Lookup values

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var hits = 0;

  var _iterator2 = _createForOfIteratorHelper(ref),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var item = _step2.value;
      var match = void 0;

      if (!options.deep || !item || typeof item !== 'object') {
        match = map.get(item);
      } else {
        var _iterator5 = _createForOfIteratorHelper(map.entries()),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var _step5$value = _slicedToArray(_step5.value, 2),
                _key = _step5$value[0],
                _existing2 = _step5$value[1];

            if (compare(_key, item)) {
              match = _existing2;
              break;
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }

      if (match) {
        ++match.hits;
        ++hits;

        if (options.once && match.hits > match.allowed) {
          return false;
        }
      }
    } // Validate results

  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  if (options.only && hits !== ref.length) {
    return false;
  }

  var _iterator3 = _createForOfIteratorHelper(map.values()),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _match = _step3.value;

      if (_match.hits === _match.allowed) {
        continue;
      }

      if (_match.hits < _match.allowed && !options.part) {
        return false;
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return !!hits;
};

internals.object = function (ref, values, options) {
  Assert(options.once === undefined, 'Cannot use option once with object');
  var keys = Utils.keys(ref, options);

  if (!keys.length) {
    return false;
  } // Keys list


  if (Array.isArray(values)) {
    return internals.array(keys, values, options);
  } // Key value pairs


  var symbols = Object.getOwnPropertySymbols(values).filter(function (sym) {
    return values.propertyIsEnumerable(sym);
  });
  var targets = [].concat(_toConsumableArray(Object.keys(values)), _toConsumableArray(symbols));
  var compare = internals.compare(options);
  var set = new Set(targets);

  var _iterator6 = _createForOfIteratorHelper(keys),
      _step6;

  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var key = _step6.value;

      if (!set.has(key)) {
        if (options.only) {
          return false;
        }

        continue;
      }

      if (!compare(values[key], ref[key])) {
        return false;
      }

      set.delete(key);
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }

  if (set.size) {
    return options.part ? set.size < targets.length : false;
  }

  return true;
};

internals.string = function (ref, values, options) {
  // Empty string
  if (ref === '') {
    return values.length === 1 && values[0] === '' || // '' contains ''
    !options.once && !values.some(function (v) {
      return v !== '';
    }); // '' contains multiple '' if !once
  } // Map values


  var map = new Map();
  var patterns = [];

  var _iterator7 = _createForOfIteratorHelper(values),
      _step7;

  try {
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var value = _step7.value;
      Assert(typeof value === 'string', 'Cannot compare string reference to non-string value');

      if (value) {
        var existing = map.get(value);

        if (existing) {
          ++existing.allowed;
        } else {
          map.set(value, {
            allowed: 1,
            hits: 0
          });
          patterns.push(EscapeRegex(value));
        }
      } else if (options.once || options.only) {
        return false;
      }
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }

  if (!patterns.length) {
    // Non-empty string contains unlimited empty string
    return true;
  } // Match patterns


  var regex = new RegExp("(".concat(patterns.join('|'), ")"), 'g');
  var leftovers = ref.replace(regex, function ($0, $1) {
    ++map.get($1).hits;
    return ''; // Remove from string
  }); // Validate results

  if (options.only && leftovers) {
    return false;
  }

  var any = false;

  var _iterator8 = _createForOfIteratorHelper(map.values()),
      _step8;

  try {
    for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
      var match = _step8.value;

      if (match.hits) {
        any = true;
      }

      if (match.hits === match.allowed) {
        continue;
      }

      if (match.hits < match.allowed && !options.part) {
        return false;
      } // match.hits > match.allowed


      if (options.once) {
        return false;
      }
    }
  } catch (err) {
    _iterator8.e(err);
  } finally {
    _iterator8.f();
  }

  return !!any;
};

internals.compare = function (options) {
  if (!options.deep) {
    return internals.shallow;
  }

  var hasOnly = options.only !== undefined;
  var hasPart = options.part !== undefined;
  var flags = {
    prototype: hasOnly ? options.only : hasPart ? !options.part : false,
    part: hasOnly ? !options.only : hasPart ? options.part : false
  };
  return function (a, b) {
    return DeepEqual(a, b, flags);
  };
};

internals.shallow = function (a, b) {
  return a === b;
};